/**
 * Created by matheusmorett on 9/11/17.
 */
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { SUGGESTED_ADVENTURES } from 'utils/Consts';
import { Helmet } from "react-helmet";
import { Redirect } from 'react-router-dom'
import GTM from 'utils/GTM';

import "./../assets/Adventure.scss";
import Modal from 'react-modal';

import AdventureBanner from "components/Banner/AdventureBanner";
import AdventureInfos from "./../components/AdventureInfos";
import Utils from "utils/Utils";
import PageLoader from "components/PageLoader";
import MoreAdventure from "components/MoreAdventure";
import { JSONLD, Generic } from 'react-structured-data';

@inject('AuthStore', 'AdventuresStore', 'ApplicationStore', 'PaymentStore', 'LocationStore', 'RequestStore', 'CheckoutStore')
@observer
class Adventure extends Component {

    constructor(props) {
        super(props);

        this.state = {
            url: this.props.match.params.id,
            noRequestsParams: !!localStorage.getItem("noRequestsParams") || false
        }

        this.resetNoRequestParams = this.resetNoRequestParams.bind(this)
    }

    componentWillMount() {
        const { ApplicationStore, AuthStore } = this.props;
        ApplicationStore.setMenuTiny();
        AuthStore.unsetReloadPageAfterLogin();
        this.populateAdventure();
        window.scrollTo(0, 0);
    }

    componentDidMount() {
        const { PaymentStore, RequestStore, AuthStore } = this.props;
        PaymentStore.removeDiscount();   
        RequestStore.resetRequest();
        AuthStore.setPageAfterLogin(window.location.pathname)
    }

    componentWillUnmount() {
        const { ApplicationStore, AuthStore } = this.props;
        ApplicationStore.unsetMenuTiny();
        AuthStore.setPageAfterLogin();
    }

    componentDidUpdate() {
        if(this.state.url !== this.props.match.params.id){
            this.populateAdventure();
            window.scrollTo({
                'behavior': 'smooth',
                'left': 0,
                'top': 0
            });
            this.setState({
                url: this.props.match.params.id
            });
        }
    }

    handleGoToPayment(params) {
        const { AuthStore, ApplicationStore, AdventuresStore, CheckoutStore, history } = this.props;

        // localStorage.setItem('requestParams', JSON.stringify(params));
        CheckoutStore.registerCheckoutData(params).then(() => {
            let url = ''
            if (ApplicationStore.minimalTemplate) {
                url = '/site/' + AdventuresStore.Adventure.company_url + '/' + AdventuresStore.Adventure.urlName + "/checkout"
            } else {
                url = AdventuresStore.Adventure.urn + "/checkout"
            }
    
            if (this.state.token) {
                url += "/" + this.state.token
            }

            url += `?cart=${CheckoutStore.pk_cart}`
            
            if (AuthStore.isLogged === true) {
                history.push(url);
            } else {
                AuthStore.setPageAfterLogin(url);
                ApplicationStore.openModalLogin();
            }
        })
    }

    handleGoToIGo(token, params) {
        const { AdventuresStore, history } = this.props;

        localStorage.setItem('requestParams', JSON.stringify(params));
        history.push(AdventuresStore.Adventure.urlName + "/checkout/" + token);
    }

    populateAdventure() {
        const { AdventuresStore, AuthStore, ApplicationStore, LocationStore, match, history } = this.props;

        AdventuresStore.getByUrlName({
            url_name: match.params.id,
        }).then(() => {
            if(AdventuresStore.Adventure) {
                ApplicationStore.setTagCode(AdventuresStore.Adventure.company_tag_code)
                let params;
                if(AuthStore.isLogged === true) {
                    params = {
                        pk_adventure: AdventuresStore.Adventure.pkAdventure,
                        fk_user: (AuthStore.authUser.pk_user)
                    }
                } else {
                    params = {
                        pk_adventure: AdventuresStore.Adventure.pkAdventure
                    }
                }
                // GTM.dispatch('telaAventura',
                //     {'ecommerce': {
                //         'detail': {
                //             'actionField': {'list': 'Página da aventura'},
                //             'products': [{
                //                 'nome': AdventuresStore.Adventure.title,
                //                 'id': AdventuresStore.Adventure.pkAdventure,
                //                 'tipo':  AdventuresStore.Adventure.typeName,
                //             }]
                //         }
                //     }}
                // );
                params.region = LocationStore.region ? LocationStore.region.url_name : ""

                AdventuresStore.getAdventureByTags(params);
                Utils.getIp().then((res) => {
                    AdventuresStore.saveAdventureEntrance({
                        fkAdventure: AdventuresStore.Adventure.pkAdventure,
                        ip: res.ip
                    });
                });
            }
        }).catch(err => {
            if(err.data){
                if(err.data.status === 404){
                    console.error(err)
                    history.push('/404');
                } else if(err.data.status === 301) {
                    history.push(err.data.message)
                }
            }
        });
    }

    resetNoRequestParams() {
        localStorage.removeItem("noRequestsParams")
        this.setState({ noRequestsParams: false })
    }

    setFavorite(params) {
        const { AdventuresStore } = this.props;
        AdventuresStore.setFavorite(params).then(() =>
            this.populateAdventure()
        );
    }

    unsetFavorite(params) {
        const { AdventuresStore } = this.props;
        AdventuresStore.unsetFavorite(params).then(() =>
            this.populateAdventure()
        );
    }

    setFeedback(params) {
        const { AdventuresStore } = this.props;
        AdventuresStore.setFeedback(params);
    }

    unsetFeedback(params) {
        const { AdventuresStore } = this.props;
        AdventuresStore.unsetFeedback(params);
    }

    render() {

        const customStyles = {
            content: {
                top: '50%',
                left: '50%',
                right: 'auto',
                bottom: 'auto',
                marginRight: '-50%',
                transform: 'translate(-50%, -50%)',
                display: 'flex',
                background: 'none',
                boxShadow: 'none',
                zIndex: '999',
                backgroundColor: "rgba(255, 255, 255, 0.9);"
            }
        };

        const { AdventuresStore, ApplicationStore, RequestStore, AuthStore } = this.props;

        return (
            <div className="Adventure">
                {(ApplicationStore.redirect.status && <Redirect to={ApplicationStore.redirect.page} state={{ status: 301 }} />)}
                {(AdventuresStore.Adventure &&
                <Helmet>
                    <meta property="og:url" content={window.location.href} />
                    <meta property="og:type" content="article" />
                    <title>{(AdventuresStore.Adventure ? AdventuresStore.Adventure.categoryName + " | "  + AdventuresStore.Adventure.title : "Adrena.me")}</title>
                    <meta property="og:title" content={(AdventuresStore.Adventure ? AdventuresStore.Adventure.categoryName + " | "  + AdventuresStore.Adventure.title : "Adrena.me")} />
                    <meta property="og:description" content={(AdventuresStore.Adventure ? AdventuresStore.Adventure.description : "Saia da rotina, viva a adrenalina")} />
                    <meta name="description" content={(AdventuresStore.Adventure ? AdventuresStore.Adventure.description : "Saia da rotina, viva a adrenalina")} />
                    <meta property="og:image" content={(AdventuresStore.Adventure ? AdventuresStore.Adventure.image : "https://s3-sa-east-1.amazonaws.com/adrenalyze/adrenalyze/banner.jpg")}/>
                    <meta name="robots" content="index, follow" />
                    <link rel="canonical" href={AdventuresStore.Adventure.url} />
                    
                </Helmet>)}
                <PageLoader loading={(!AdventuresStore.Adventure)}>
                    <AdventureBanner
                        Adventure={AdventuresStore.Adventure}
                    />
                    <AdventureInfos
                        Adventure={AdventuresStore.Adventure}
                        goToPayment={this.handleGoToPayment.bind(this)}
                        goToIGo={this.handleGoToIGo.bind(this)}
                    >
                    </AdventureInfos>
                    {(AdventuresStore.SuggestedAdventures.length > 0 || AdventuresStore.loading) && !ApplicationStore.minimalTemplate ?
                        <MoreAdventure
                            Adventures={AdventuresStore.SuggestedAdventures}
                            typeSearch={SUGGESTED_ADVENTURES}
                            moreSearch={false}
                            marginScrollBottom={false}
                            pkAdventure={(AdventuresStore.Adventure !== undefined ? AdventuresStore.Adventure.pk_adventure : null)}
                            title="Mais Adrena para o seu dia"
                        />
                        : <div className="more-adventure" />
                    }
                    {AdventuresStore.Adventure &&
                    <JSONLD>
                        <Generic 
                            type="BreadcrumbList"
                            jsonldtype="BreadcrumbList"
                            schema={{
                                itemListElement: [
                                    {
                                        "@type": "listItem",
                                        item: { 
                                            url: `${window.location.origin}/`,
                                            name: 'Inicio', 
                                            "@id": 'Inicio' 
                                        },
                                        position: 1
                                    },
                                    {
                                        "@type": "listItem",
                                        item: { 
                                            url: `/${AdventuresStore.Adventure.region_url}`,
                                            name: AdventuresStore.Adventure.region_name,
                                            "@id": AdventuresStore.Adventure.region_name
                                        },
                                        position: 2
                                    },
                                    {
                                        "@type": "listItem",
                                        item: { 
                                            url: `/${AdventuresStore.Adventure.region_url}/${AdventuresStore.Adventure.categoryUrl}`,
                                            name: AdventuresStore.Adventure.categoryTitle,
                                            "@id": AdventuresStore.Adventure.categoryTitle
                                        },
                                        position: 3
                                    },
                                    {
                                        "@type": "listItem",
                                        item: { 
                                            url: AdventuresStore.Adventure.urn,
                                            name: AdventuresStore.Adventure.title,
                                            "@id": AdventuresStore.Adventure.title
                                        },
                                        position: 4
                                    }
                                ],
                                numberOfItems: 4
                            }}
                        />
                    </JSONLD>
                    }
                    {AdventuresStore.Adventure && 
                    <JSONLD>
                        <Generic 
                            type="Product"
                            jsonldtype="Product"
                            schema={{
                                name: AdventuresStore.Adventure.title,
                                image: AdventuresStore.Adventure.image,
                                description: AdventuresStore.Adventure.description || AdventuresStore.Adventure.long_description,
                                url: window.location.href,
                                category: AdventuresStore.Adventure.categoryName,
                                areaServed: `${AdventuresStore.Adventure.lat}, ${AdventuresStore.Adventure.lng}`
                            }}
                        >
                            <Generic 
                                type="Brand"
                                jsonldtype="Brand"
                                schema={{
                                    name: AdventuresStore.Adventure.company
                                }}
                            />
                            <Generic 
                                type="offers"
                                jsonldtype="Offer"
                                schema={{
                                    price: AdventuresStore.Adventure.price,
                                    priceCurrency: 'BRL',
                                    availability: !!AdventuresStore.Adventure.nextDate || AdventuresStore.Adventure.voucher_enabled ? "https://schema.org/OnlineOnly" : "https://schema.org/OutOfStock"
                                }}
                            />
                        </Generic>
                    </JSONLD>
                    }
                </PageLoader>
                {!!this.state.noRequestsParams && 
                <Modal
                    isOpen={!!this.state.noRequestsParams}
                    style={customStyles}
                    onRequestClose={() => this.resetNoRequestParams()}
                >
                    <div className="box-modal">
                        <div className="Grid Grid--gutter Grid-column">
                            <div className="Grid-cell">
                                <div className="close-modal">
                                    <p className="float-right" onClick={() => this.resetNoRequestParams()}>
                                        Fechar X
                                    </p>
                                </div>
                            </div>
                            <div className="Grid-cell">
                                <div className="modal-content content-cancel-rules">
                                    <h4>Erro no Checkout</h4>
                                    <p className='text'>
                                        Encontramos um problema ao resgatar sua seleção de horário. Isso pode ser causado pelas suas configurações de navegador. Verifique as suas configurações de compartilhamento de dados.<br/>
                                        <b>Por favor, selecione novamente o horário desejado nesta página.</b>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>
                }
            </div>
        )
    }

}

export default Adventure;